import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import { getLanguageFromLocale } from '../../helpers/translations';

// CSS files included in ./src/style.css to make sure the PostCSS plugin processes them

declare global {
  interface Window {
    hbspt?: any;
  }
}

interface HubspotFormProps {
  formId: string | undefined;
  formClass?: string;
  submitButtonClass?: string;
  className?: string;
}

const addLastPassIgnore = (form: HTMLFormElement) => {
  const emailField = form.querySelector('input[type="email"]');
  if (!emailField) return;

  emailField.setAttribute('data-lpignore', 'true');
};

const HubspotForm = ({
  formId, formClass, submitButtonClass = 'submitButtonClass', className = '',
}: HubspotFormProps) => {
  const intl = useIntl();
  const localeCode = getLanguageFromLocale(intl.locale);

  const createHSForm = () => {
    if (window?.hbspt && formId) {
      window.hbspt.forms.create({
        region: 'na1',
        portalId: process.env.GATSBY_HUBSPOT_PORTAL_ID,
        formId,
        locale: localeCode,
        cssClass: cx(formClass, 'hubspot-form'),
        onFormReady: addLastPassIgnore,
        submitButtonClass,
        target: `#hubspotForm-${formId}`,
      });
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    document.body.appendChild(script);
    script.addEventListener('load', createHSForm);

    return () => {
      document.body.removeChild(script);
      script.removeEventListener('load', createHSForm);
    };
  }, []);

  return (
    <div className="pd-max-w-3xl">
      <div id={`hubspotForm-${formId}`} className={cx('hubspot-form-container', className)} />
    </div>
  );
};

export default HubspotForm;
